

















































































































































































































































































































































































































































































































import {
  computed,
  createComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  SetupContext
} from '@vue/composition-api'
import NoSleep from '~/node_modules/nosleep.js'
import moment from '~/node_modules/moment'
import ButtonOperatorComponent from '~/components/common/button_operator.vue'
import VehicleDeselectCompornent from '~/components/pages/vehicle_deselect.vue'
import DailyReportComponent from '@/components/pages/daily_report.vue'
import DriverScheduleComponent from '@/components/pages/driver_schedule.vue'
import { configType } from '~/models/config_driver_app'
import { firebaseApp } from '~/plugins/firestore'
import { drivingMode, driving } from '~/components/common/driving'
import NewMessageComponent from '~/components/common/new_message.vue'
import InformationComponent from '@/components/pages/information.vue'
import { getDriverReadMessages } from '@/models/api/user'
import manifest from '@/static/manifest.json'

export default createComponent({
  components: {
    ButtonOperatorComponent,
    VehicleDeselectCompornent,
    DailyReportComponent,
    DriverScheduleComponent,
    InformationComponent,
    NewMessageComponent
  },
  setup(_props, context: SetupContext) {
    const isMode = ref<string>(process.env.ctiEnv)
    const isDrivingMode = ref<boolean>(driving.isDriving())
    const isDrivingPlay = ref<boolean>(driving.isPlay())
    const showStatusGPS = ref<boolean>(false)
    const statusGPS = ref<string>('')

    const manifestJson = JSON.stringify(manifest)
    const manifestScript = JSON.parse(manifestJson)
    const version = isMode.value + '@' + manifestScript.version
    const noSleep = ref<any>(null)
    onMounted(async () => {
      noSleep.value = new NoSleep()
      if (!noSleep.value.isEnabled) {
        await noSleep.value.enable()
      }
      await fetchDriverReadMessages()
    })
    onBeforeUnmount(() => {
      clearAllInterval()
      noSleep.value = null
    })
    const isLoading = ref<boolean>(false)
    const isSessionError = ref<Boolean>(false)
    const snackbar = ref<boolean>(false)
    const snackBarTimeout = ref<number>(5000)
    context.root.$nuxt.$on('SessionError', () => {
      clearAllInterval()
      isSessionError.value = true
    })
    context.root.$nuxt.$on('NetworkError', (error: any) => {
      if (
        !context.root.$auth.loggedIn ||
        error.message === 'Request failed with status code 401'
      ) {
        context.root.$nuxt.$emit('SessionError')
      } else {
        snackbar.value = true
      }
    })
    const isloggedInSameUser = ref<boolean>(false)
    const menuDrawer = ref<boolean>(false)
    context.root.$nuxt.$on('closeMenuDrawer', () => {
      menuDrawer.value = false
    })
    const getConfigDriverApp = async () => {
      let config_maptype = 'roadmap'
      let config_headingup = false
      await context.root.$axios
        .$get(`/config_driver_app/me`)
        .then((res: any) => {
          if (res && res.length > 0) {
            res.forEach((r: any) => {
              if (r.config_key === configType.MAPTYPE)
                config_maptype = r.config_value
              if (r.config_key === configType.HEADINTGUP)
                config_headingup = r.config_value.toLowerCase() === 'true'
            })
          }
        })
        .finally(() => {
          context.root.$store.commit('updateMapType', {
            maptype: config_maptype
          })
          context.root.$store.commit('updateSetHeadingUp', {
            isHeadingUp: config_headingup
          })
        })
    }

    if (context.root.$auth.loggedIn) {
      getConfigDriverApp()
    } else {
      context.root.$router.push({
        path: '/login/'
      })
    }

    const user: any = computed(() => {
      return context.root.$auth.loggedIn
        ? context.root.$auth.user
        : { id: '', username: '' }
    })
    // const user_id = ref<number>(user.value.id)
    const userName = ref<string>(user.value.username)
    const vehicleID = computed(() => {
      return context.root.$store.state.vehicleID
    })
    const overlay = ref<boolean>(false)
    const showVehicleDeselect = ref<boolean>(false)
    const showDailyReport = ref<boolean>(false)
    const showDriverSchedule = ref<boolean>(false)
    const showInformation = ref<boolean>(false)
    const vehicleStatus = computed(() => {
      return context.root.$store.state.vehicleStatus
    })
    const driverScheduleRefComponent = ref<any>(null)
    const showDriverScheduleComponent = () => {
      showDriverSchedule.value = true
      if (driverScheduleRefComponent.value != null)
        driverScheduleRefComponent.value.fetchGetOrders()
    }

    const dailyReportRefComponent = ref<any>(null)
    const showDailyReportComponent = () => {
      showDailyReport.value = true
      if (dailyReportRefComponent.value != null)
        dailyReportRefComponent.value.fetchVehicleDailyReports()
    }
    const formatDate = ref<string>('')
    const IntervalDisplayDateTime = 1000
    const IntervalDisplayDateTimeID = window.setInterval(() => {
      formatDate.value = moment().format('YYYY/MM/DD HH:mm')
      // セッションが切れたら自動ログアウトする
      if (!context.root.$auth.loggedIn) {
        context.root.$nuxt.$emit('SessionError')
      }
    }, IntervalDisplayDateTime)
    const fetchDriverReadMessages = async () => {
      if (context.root.$auth.user) {
        // メッセージID配列を取得
        await getDriverReadMessages(context.root.$axios)
          .then((response: any) => {
            context.root.$store.commit('message/markAsReadMessage', response)
          })
          .catch((error: any) => {
            context.root.$nuxt.$emit('NetworkError', error)
          })
      }
    }
    const clearAllInterval = () => {
      clearInterval(IntervalDisplayDateTimeID)
    }

    const daily_report = () => {
      context.root.$router.push('/daily_report/')
    }
    const driver_schedule = () => {
      context.root.$router.push('/driver_schedule/')
    }
    const drivingBreak = () => {
      const param = [
        {
          op: 'replace',
          path: '/status_rest',
          value: true
        }
      ]
      context.root.$axios
        .$patch(`/vehicles/${vehicleID.value}`, param)
        .then(() => {
          overlay.value = true
          context.root.$store.commit('updateStatusVehicle', {
            vehicleStatus: 'REST'
          })
        })
        .catch((error: any) => {
          context.root.$nuxt.$emit('NetworkError', error)
        })
    }
    const drivingBreakFinish = () => {
      const param = [
        {
          op: 'replace',
          path: '/status_active',
          value: true
        }
      ]
      context.root.$axios
        .$patch(`/vehicles/${vehicleID.value}`, param)
        .then(() => {
          overlay.value = false
          context.root.$store.commit('updateStatusVehicle', {
            vehicleStatus: 'PREACTIVE'
          })
        })
        .catch((error: any) => {
          context.root.$nuxt.$emit('NetworkError', error)
        })
    }
    const maptype = computed(() => {
      return context.root.$store.state.maptype
    })
    const changeMapType = () => {
      const config_maptype =
        maptype.value === configType.MAPTYPE_ROADMAP
          ? configType.MAPTYPE_HYBRID
          : configType.MAPTYPE_ROADMAP
      context.root.$axios
        .$patch(
          `/config_driver_app/me?config_key=${configType.MAPTYPE}&config_value=${config_maptype}`
        )
        .then(() => {
          context.root.$store.commit('updateMapType', {
            maptype: config_maptype
          })
        })
        .catch((error: any) => {
          context.root.$nuxt.$emit('NetworkError', error)
        })
    }
    const isHeadingUp: any = computed(() => {
      return context.root.$store.state.isHeadingUp
    })
    const setHeadingUp = () => {
      const config_headingup = !isHeadingUp.value
      context.root.$axios
        .$patch(
          `/config_driver_app/me?config_key=${configType.HEADINTGUP}&config_value=${config_headingup}`
        )
        .then(() => {
          context.root.$store.commit('updateSetHeadingUp', {
            isHeadingUp: config_headingup
          })
        })
        .catch((error: any) => {
          context.root.$nuxt.$emit('NetworkError', error)
        })
    }
    const done_drivestop = ref<Boolean>(false)
    const routeback = () => {
      isLoading.value = true
      drivingInit()
      const param = [
        {
          op: 'replace',
          path: '/current_order',
          value: null
        },
        {
          op: 'replace',
          path: '/order_type',
          value: null
        },
        {
          op: 'replace',
          path: '/status_active',
          value: true
        }
      ]
      context.root.$axios
        .$patch(`/vehicles/${vehicleID.value}`, param)
        .then(() => {
          context.root.$nuxt.$emit('emergencyStop')
          done_drivestop.value = false
        })
        .catch((error: any) => {
          context.root.$nuxt.$emit('NetworkError', error)
        })
        .finally(() => {
          isLoading.value = false
        })
    }
    const drivingInit = () => {
      driving.initPlay()
      driving.setStop()
      isDrivingPlay.value = driving.isPlay()
    }
    const drivingPlay = () => {
      driving.initPlay()
      isDrivingPlay.value = isDrivingPlay.value
        ? driving.setStop()
        : driving.setPlay()
      context.root.$nuxt.$emit('changeDrivingPlay', isDrivingPlay.value)
    }
    context.root.$nuxt.$on('changeDrivingMode', (val: boolean) => {
      isDrivingMode.value = driving.changeMode(val)
    })
    context.root.$nuxt.$on('statusGPS', (val: string) => {
      statusGPS.value = val
    })
    context.root.$nuxt.$on('logout', () => {
      logout()
    })
    context.root.$nuxt.$on('resetStatus', () => {
      context.root.$store.commit('updateCurrentVehicleId', {
        vehicleID: ''
      })
      context.root.$store.commit('updateCurrentVehicleName', {
        vehicleName: ''
      })
      context.root.$store.commit('updateStatusVehicle', {
        vehicleStatus: 'INACTIVE'
      })
    })
    const resetDrivingBreak = () => {
      const selectVehicle = [
        {
          op: 'replace',
          path: '/status_inactive',
          value: true
        }
      ]
      context.root.$axios
        .$patch(`/vehicles/${vehicleID.value}`, selectVehicle)
        .catch(console.error)
    }
    context.root.$nuxt.$on('resetDialog', () => {
      if (showDriverSchedule.value) showDriverSchedule.value = false
      if (showDailyReport.value) showDailyReport.value = false
      if (showInformation.value) showInformation.value = false
      if (overlay.value) {
        resetDrivingBreak()
        overlay.value = false
      }
      if (done_drivestop.value) done_drivestop.value = false
    })
    const logout = async () => {
      if (vehicleID.value) {
        const selectVehicle = [
          {
            op: 'replace',
            path: '/is_selected',
            value: false
          },
          {
            op: 'replace',
            path: '/status_inactive',
            value: true
          }
        ]
        await context.root.$axios
          .$patch(`/vehicles/${vehicleID.value}`, selectVehicle)
          .then(() => {
            context.root.$nuxt.$emit('resetStatus')
          })
          .catch(console.error)
      }
      // firestoreリセット
      context.root.$store.commit('message/resetState')
      await context.root.$auth
        .logout()
        .then(() => {
          context.root.$router.push('/login/')
        })
        .catch(console.error)
      await firebaseApp
        .auth()
        .signOut()
        .catch(console.error)
    }
    const logout_session_err = async () => {
      // statusリセット（車両）
      context.root.$nuxt.$emit('resetStatus')
      // firestoreリセット
      context.root.$store.commit('message/resetState')
      await context.root.$auth
        .logout()
        .then(() => {
          isSessionError.value = false
          context.root.$router.push('/login/')
        })
        .catch(console.error)
    }
    const checkLoginSameUser = async () => {
      const param = {
        app_type: 'navi_app'
      }
      const params = new URLSearchParams(param)
      await context.root.$axios
        .$post(`/auth/check_login_same_user`, params)
        .then((res: any) => {
          isloggedInSameUser.value = res.result
          // statusリセット（車両）
          context.root.$nuxt.$emit('resetStatus')
        })
        .catch(console.error)
    }
    if (context.root.$auth.loggedIn) {
      checkLoginSameUser()
    }

    // firebaseの認証されていない場合は、動かさないようにする
    const auth = firebaseApp.auth()
    auth.onAuthStateChanged((user: any) => {
      if (user) {
        // 対象のメッセージをバインドする
        context.root.$store.dispatch('message/bindMessages')
      }
    })

    const isOnLine = ref<boolean>(true)
    window.addEventListener('online', () => {
      isOnLine.value = true
    })
    window.addEventListener('offline', () => {
      isOnLine.value = false
    })
    return {
      version,
      isLoading,
      drivingMode,
      isMode,
      isDrivingMode,
      isDrivingPlay,
      showStatusGPS,
      statusGPS,
      drivingPlay,
      formatDate,
      userName,
      menuDrawer,
      daily_report,
      driver_schedule,
      vehicleStatus,
      drivingBreak,
      drivingBreakFinish,
      overlay,
      changeMapType,
      routeback,
      done_drivestop,
      maptype,
      setHeadingUp,
      isHeadingUp,
      logout,
      logout_session_err,
      showVehicleDeselect,
      showDailyReport,
      showDriverSchedule,
      showInformation,
      isloggedInSameUser,
      isSessionError,
      showDailyReportComponent,
      dailyReportRefComponent,
      showDriverScheduleComponent,
      driverScheduleRefComponent,
      snackbar,
      snackBarTimeout,
      isOnLine
    }
  }
})
